module.exports = __webpack_public_path__ + "static/media/grandcanyon1.6af02b99.jpg";